export const CLIENT_ID = 'meglerpromo';

export const REFERRAL_SOURCE_PARAM = 'utm_source';

export const PRISTIPS_URL = 'https://www.finn.no/eiendom/pristips';
export const ESTIMATE_URL = 'https://www.finn.no/eiendom/pristips/ditt-pristips';

export function withReferralSource(url: string): string {
    const referralUrl = new URL(url);
    referralUrl.searchParams.set(REFERRAL_SOURCE_PARAM, CLIENT_ID);
    return referralUrl.toString();
}
